import { LockOpenOutlined, LockOutlined } from '@mui/icons-material';
import { IconButton, InputAdornment, Tooltip } from '@mui/material';
import React from 'react';

interface PrivacyToggleProps {
  isPrivate: boolean;
  onToggle: () => void;
  disabled?: boolean;
  iconColor?: string;
  padding?: string;
}

const PrivacyToggle: React.FC<PrivacyToggleProps> = ({
  isPrivate,
  onToggle,
  disabled = false,
  iconColor = '#070154',
  padding = '0px',
}) => {
  return (
    <InputAdornment position="end">
      <Tooltip
        PopperProps={{ placement: 'top' }}
        title={`Make Chat ${isPrivate ? 'Public' : 'Private'}`}
      >
        <span>
          <IconButton onClick={onToggle} sx={{ color: iconColor, padding }} disabled={disabled}>
            {isPrivate ? <LockOutlined /> : <LockOpenOutlined />}
          </IconButton>
        </span>
      </Tooltip>
    </InputAdornment>
  );
};

export default PrivacyToggle;
